import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import { ButtonGroup, IconButton, ListItem, TextField } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'

import SvgIcon from '@material-ui/icons/Search'
import CircularProgress from '@material-ui/core/CircularProgress'

const FarmerFilterModal = props => {

  const farmers = props.isContainers === true ? props.farmersContainers : props.farmers;

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle id='confirmation-dialog-title'>Agricultores</DialogTitle>
      <DialogContent>
        <ButtonGroup fullWidth>
          <TextField
            fullWidth
            value={props.farmerSelect}
            onChange={props.setFarmerSelect}
            id='outlined-basic' label='Agricultor' variant='outlined' />

          <IconButton
            onClick={props.findFarmers}
            aria-label='Copy to clipboard'
            title='Copy to clipboard'
            color='primary'
            edge='end' >
            <SvgIcon />
          </IconButton>
        </ButtonGroup>

        <List>
          {farmers.map((farmer, idx) => {
            return (
              <div className='farmer_div' style={{ width: '100%' }} key={farmer.id}>
                <ListItem
                  className={props.classes.farmer}
                  key={farmer.id}
                  dense
                  button
                  disableGutters
                  onClick={() => props.onChecked(farmer.id)}>
                  <Checkbox
                    checked={props.selectedFarmers.indexOf(farmer.id) > -1}
                    disableRipple
                    classes={{ root: props.classes.checkbox }}
                    color='primary'
                  />
                  <ListItemText>{farmer.name}</ListItemText>
                </ListItem>
              </div>
            )
          }
          )}

          {
            props.loadingFarmers && (<span style={{textAlign: 'center', display: 'block', width: '100%'}}>
              <CircularProgress color='primary' />
            </span>)
          }

          <br />
          <Button
            style={{margin: 'auto', width: '100%'}}
            onClick={() => { props.loadFarmersPaginated() }
            }
          >
            Cargar más
          </Button>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onReset}>Borrar</Button>
        <Button onClick={props.onClose} variant='contained' color='primary'>
          Filtrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const styles = {
  farm: {},
  greenhouse: {
    padding: 0
  },
  checkbox: {
    height: 30,
    '& input': {
      padding: 0
    }
  }
}

export default withStyles(styles)(FarmerFilterModal)



// WEBPACK FOOTER //
// ./src/components/FarmerFilterModal.js